const menuToggle = document.querySelector("[data-menu-toggle]");
const menu = document.querySelector("[data-menu]");

menuToggle?.addEventListener("click", () => {
  const isOpen = menu?.classList.toggle("is-open");
  menuToggle.setAttribute("aria-expanded", String(Boolean(isOpen)));
});

const mysteryMenus = [...document.querySelectorAll("[data-mystery-nav]")];
const setMysteryMenu = (item, open) => {
  item.querySelector("[data-mystery-toggle]").setAttribute("aria-expanded", String(open));
  item.querySelector(".mystery-nav__panel").hidden = !open;
};

mysteryMenus.forEach((item) => {
  const toggle = item.querySelector("[data-mystery-toggle]");
  let openedByHover = false;
  toggle.addEventListener("click", () => {
    const open = openedByHover || toggle.getAttribute("aria-expanded") !== "true";
    openedByHover = false;
    mysteryMenus.forEach((other) => setMysteryMenu(other, other === item && open));
  });
  item.addEventListener("pointerenter", () => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    openedByHover = toggle.getAttribute("aria-expanded") !== "true";
    mysteryMenus.forEach((other) => setMysteryMenu(other, other === item));
  });
  item.addEventListener("pointerleave", () => {
    openedByHover = false;
    if (!item.contains(document.activeElement)) setMysteryMenu(item, false);
  });
  item.addEventListener("focusout", (event) => {
    if (!item.contains(event.relatedTarget)) setMysteryMenu(item, false);
  });
  item.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    openedByHover = false;
    setMysteryMenu(item, false);
    toggle.focus();
  });
});

document.addEventListener("click", (event) => {
  mysteryMenus.forEach((item) => {
    if (!item.contains(event.target)) setMysteryMenu(item, false);
  });
});

const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

document.querySelectorAll("[data-slider]").forEach((slider) => {
  const track = slider.querySelector(".slides-track");
  const slides = [...slider.querySelectorAll(".slide")];
  const dots = [...slider.querySelectorAll(".s-dot")];
  let current = 0;
  let timer;

  const goTo = (index) => {
    current = (index + dots.length) % dots.length;
    track.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((dot, dotIndex) => dot.classList.toggle("on", dotIndex === current));
    slides.forEach((slide, slideIndex) => slide.classList.toggle("is-current", slideIndex === current));
    slider.dataset.slide = String(current);
    slider.dispatchEvent(new CustomEvent("hero:slide", { detail: current }));
  };
  const restart = () => {
    clearInterval(timer);
    timer = setInterval(() => goTo(current + 1), 6000);
  };

  dots.forEach((dot, index) => dot.addEventListener("click", () => { goTo(index); restart(); }));

  let touchX = null;
  slider.addEventListener("touchstart", (event) => { touchX = event.touches[0].clientX; }, { passive: true });
  slider.addEventListener("touchend", (event) => {
    if (touchX === null) return;
    const delta = event.changedTouches[0].clientX - touchX;
    touchX = null;
    if (Math.abs(delta) < 45) return;
    goTo(current + (delta < 0 ? 1 : -1));
    restart();
  });

  restart();
});

// Hero: animazioni CSS in pausa fuori schermo (la scena WebGL e in hero-3d.js)
document.querySelectorAll("[data-hero3d]").forEach((hero) => {
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => hero.classList.toggle("is-paused", !entry.isIntersecting)).observe(hero);
  }
});

// Filtro prodotti per gioco
document.querySelectorAll(".prod-tabs").forEach((tabs) => {
  const grid = tabs.parentElement?.querySelector(".product-grid");
  const cards = grid ? [...grid.querySelectorAll("[data-filter-text]")] : [];
  let empty = null;

  tabs.querySelectorAll(".p-tab").forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.querySelectorAll(".p-tab").forEach((item) => item.classList.remove("on"));
      tab.classList.add("on");
      if (!cards.length) return;

      const filter = (tab.dataset.filter || "").toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const match = !filter || card.dataset.filterText.includes(filter);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (!empty) {
        empty = document.createElement("p");
        empty.className = "product-grid__empty";
        empty.textContent = "Nessun prodotto per questa categoria al momento.";
        grid.append(empty);
      }
      empty.hidden = visible > 0;
    });
  });
});

// Galleria prodotto: immagini, video e modelli 3D
const galleryStage = document.querySelector("[data-gallery-stage]");

document.querySelectorAll("[data-product-thumb]").forEach((thumb) => {
  thumb.addEventListener("click", () => {
    if (!galleryStage) return;
    galleryStage.querySelectorAll("[data-media-id]").forEach((slide) => {
      const active = slide.dataset.mediaId === thumb.dataset.mediaId;
      if (!active) slide.querySelector("video")?.pause();
      slide.hidden = !active;
    });
    galleryStage.classList.toggle("has-model", Boolean(galleryStage.querySelector(".product-gallery__slide--model:not([hidden])")));
    thumb.parentElement?.querySelectorAll("[data-product-thumb]").forEach((item) => item.classList.remove("is-active"));
    thumb.classList.add("is-active");
  });
});

const trackTilt = (element, onMove, onLeave) => {
  let frame = 0;
  element.addEventListener("pointermove", (event) => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const rect = element.getBoundingClientRect();
      onMove((event.clientX - rect.left) / rect.width, (event.clientY - rect.top) / rect.height);
    });
  });
  element.addEventListener("pointerleave", () => {
    cancelAnimationFrame(frame);
    frame = 0;
    onLeave();
  });
};

const setTilt = (element, x, y, strength) => {
  element.style.setProperty("--rx", `${((0.5 - y) * strength).toFixed(2)}deg`);
  element.style.setProperty("--ry", `${((x - 0.5) * strength).toFixed(2)}deg`);
  element.style.setProperty("--mx", `${(x * 100).toFixed(1)}%`);
  element.style.setProperty("--my", `${(y * 100).toFixed(1)}%`);
};
const resetTilt = (element) => {
  element.style.setProperty("--rx", "0deg");
  element.style.setProperty("--ry", "0deg");
};

const flatStyle = document.body.classList.contains("style-flat");

if (!reduceMotion && finePointer && !flatStyle) {
  // Tilt 3D con riflesso olografico su card e riquadri
  document.querySelectorAll(".product-card, .cat-card, .collector-strip article, .promo-card, .social-card, .trust article, .mystery-choice").forEach((card) => {
    const glare = document.createElement("i");
    glare.className = "fx-glare";
    glare.setAttribute("aria-hidden", "true");
    card.append(glare);
    card.classList.add("fx-tilt");
    const strength = card.classList.contains("product-card") ? 16 : 10;
    trackTilt(
      card,
      (x, y) => { card.classList.add("is-tilting"); setTilt(card, x, y, strength); },
      () => { card.classList.remove("is-tilting"); resetTilt(card); }
    );
  });

  // Tilt sull'immagine prodotto (non sul modello 3D, che si ruota trascinando)
  if (galleryStage) {
    galleryStage.classList.add("fx-stage");
    galleryStage.classList.toggle("has-model", Boolean(galleryStage.querySelector(".product-gallery__slide--model:not([hidden])")));
    trackTilt(
      galleryStage,
      (x, y) => {
        if (galleryStage.classList.contains("has-model")) return;
        galleryStage.classList.add("is-tilting");
        setTilt(galleryStage, x, y, 9);
      },
      () => { galleryStage.classList.remove("is-tilting"); resetTilt(galleryStage); }
    );
  }
}

// Comparsa allo scroll
if (!reduceMotion && "IntersectionObserver" in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-in");
      revealObserver.unobserve(entry.target);
    });
  }, { rootMargin: "0px 0px -8% 0px" });

  document.querySelectorAll(".sec-head, .trust-item, .collector-strip article, .cat-card, .product-card, .promo-card, .trust h2, .trust__proof, .trust article, .social-strip__copy, .social-card, .mystery-choice").forEach((element) => {
    const siblings = [...element.parentElement.children];
    element.style.setProperty("--d", `${Math.min(siblings.indexOf(element), 8) * 0.06}s`);
    element.classList.add("fx-reveal");
    revealObserver.observe(element);
  });
}

// Contatore animato delle vendite (es. "5.000+")
document.querySelectorAll(".trust__number").forEach((counter) => {
  const original = counter.textContent.trim();
  const match = original.match(/^([\d.]+)(.*)$/);
  if (!match || reduceMotion || !("IntersectionObserver" in window)) return;
  const target = parseInt(match[1].replace(/\./g, ""), 10);
  const suffix = match[2];
  if (!target) return;

  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) return;
    observer.disconnect();
    const start = performance.now();
    const step = (now) => {
      const progress = Math.min((now - start) / 1600, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      counter.textContent = Math.round(target * eased).toLocaleString("it-IT") + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else counter.textContent = original;
    };
    requestAnimationFrame(step);
  });
  observer.observe(counter);
});

const cookieBanner = document.querySelector("[data-cookie-banner]");
const cookieAccept = document.querySelector("[data-cookie-accept]");
const cookieKey = "tcgbrugialdi_cookie_ok";

if (cookieBanner && localStorage.getItem(cookieKey) !== "true") {
  cookieBanner.hidden = false;
}

cookieAccept?.addEventListener("click", () => {
  localStorage.setItem(cookieKey, "true");
  if (cookieBanner) cookieBanner.hidden = true;
});
